module.exports = __webpack_public_path__ + "img/newproduct.b8e04e25.jpg";